export class Eventful {
    eventType: string = ''
}